import React from 'react';
import { Layout, Typography, Card, Button, Space, message } from 'antd';
import { ExperimentOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { get } from '../utils/api';

const { Header, Content } = Layout;
const { Title, Text } = Typography;

const Test401 = () => {
  const navigate = useNavigate();
  // const { t } = useTranslation(); // 暂时不使用翻译

  const testValidApi = async () => {
    try {
      // 测试一个需要认证的有效API
      message.loading('Testing valid API call...', 0);
      await get('/api/etfportfoliolist');
      message.destroy();
      message.success('Valid API call successful');
    } catch (error) {
      message.destroy();
      console.error('Valid API test failed:', error);
      message.error('Valid API call failed - Check console for details');
    }
  };

  const test401Api = async () => {
    try {
      // 测试一个会返回401的API
      message.loading('Testing 401 API call...', 0);

      // 使用一个不存在的端点来模拟401错误
      // 或者清除token来强制触发401
      const originalToken = localStorage.getItem('access_token');

      // 先保存当前token，然后清除它来触发401
      localStorage.removeItem('access_token');

      // 尝试调用需要认证的API
      await get('/api/etfportfoliolist');

      // 如果没有跳转，恢复token
      if (originalToken) {
        localStorage.setItem('access_token', originalToken);
      }

      message.destroy();
      message.warning('401 test did not trigger redirect - Check console');
    } catch (error) {
      message.destroy();
      console.error('401 API test result:', error);
      if (error.message.includes('Unauthorized')) {
        message.info('401 error detected - Check if redirect happened');
      } else {
        message.error('401 test failed - Check console for details');
      }
    }
  };

  const clearTokensAndTest = async () => {
    // 清除所有认证信息
    const authKeys = [
      'access_token',
      'token_type',
      'expires_in',
      'userName',
      'algoChainToken',
      '.issued',
      '.expires',
      'portfolioId'
    ];

    authKeys.forEach(key => {
      localStorage.removeItem(key);
    });

    message.info('Tokens cleared. Testing API call...');

    try {
      await get('/api/etfportfoliolist');
      message.warning('API call succeeded without authentication');
    } catch (error) {
      if (error.message.includes('Unauthorized')) {
        message.success('401 error correctly detected - Should redirect to login');
      } else {
        message.error('Unexpected error - Check console');
      }
    }
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{
        background: '#fff',
        padding: '0 24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
          401 Error Interception Test
        </Title>
        <Space>
          <LanguageSwitcher />
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={handleBack}
          >
            Back to Dashboard
          </Button>
        </Space>
      </Header>

      <Content style={{ padding: '24px', background: '#f0f2f5' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <Card
            title={
              <Space>
                <ExperimentOutlined />
                API 401 Error Testing
              </Space>
            }
            style={{ marginBottom: '24px' }}
          >
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <div>
                <Title level={4}>Test Description</Title>
                <Text>
                  This page tests the 401 error interception functionality.
                  When an API call returns a 401 status, the system should automatically
                  clear authentication data and redirect to the login page.
                </Text>
              </div>

              <div>
                <Title level={4}>Test Cases</Title>
                <Space direction="vertical" style={{ width: '100%' }}>
                  <Button
                    type="primary"
                    block
                    onClick={testValidApi}
                  >
                    Test Valid API Call (with valid token)
                  </Button>

                  <Button
                    block
                    onClick={test401Api}
                    style={{ background: '#faad14', borderColor: '#faad14' }}
                  >
                    Test 401 Error (temporarily remove token)
                  </Button>

                  <Button
                    danger
                    block
                    onClick={clearTokensAndTest}
                  >
                    Clear Tokens & Test (should trigger redirect)
                  </Button>
                </Space>
              </div>

              <div>
                <Title level={4}>Expected Behavior</Title>
                <ul>
                  <li><Text strong>Valid API:</Text> Should succeed with proper authentication</li>
                  <li><Text strong>401 Error:</Text> Should show error message but may not redirect (token restored)</li>
                  <li><Text strong>Clear Tokens:</Text> Should trigger automatic redirect to login page</li>
                </ul>
              </div>

              <div>
                <Title level={4}>Current Authentication Status</Title>
                <Space direction="vertical">
                  <Text>Token exists: {localStorage.getItem('access_token') ? '✅ Yes' : '❌ No'}</Text>
                  <Text>Portfolio ID: {localStorage.getItem('portfolioId') || 'Not set'}</Text>
                </Space>
              </div>
            </Space>
          </Card>
        </div>
      </Content>
    </Layout>
  );
};

export default Test401;